import type { NormalizedSchema, schema as normalizerSchema } from 'normalizr';
import { normalize } from 'normalizr';

export const normalizeResponse = <T, I = string[]>(
  responseData: unknown,
  schema: normalizerSchema.Entity<unknown>[] | normalizerSchema.Entity<unknown>,
): NormalizedSchema<T, I> => {
  return normalize(responseData, schema);
};
